import type { DropdownNavigationItem, NavigationGroupModel } from '../../../../types';

// Whatever a drawer row opens into next: a root dropdown item (panel or sidebar) or a
// column group. Both are already part of the shared, Contentful-mapped model — mobile just
// chooses to present them as their own screen instead of rendering them inline like desktop.
export type DrawerNode = DropdownNavigationItem | NavigationGroupModel;

export const isGroupNode = (node: DrawerNode): node is NavigationGroupModel => 'links' in node;
